export default class IOSBridge {
  private static instance: IOSBridge | null = null;
  private webkit: any = null;
  private initialized = false;

  private initialize() {
    if (this.initialized) return;
    this.webkit = (window as any).webkit?.messageHandlers || null;
    this.initialized = true;
  }

  public static getInstance(): IOSBridge {
    if (!IOSBridge.instance) {
      IOSBridge.instance = new IOSBridge();
    }
    return IOSBridge.instance;
  }

  public sendUserData(data: any): void {
    this.initialize();
    if (!this.isIOSAvailable()) return;
    try {
      this.webkit.sendUserData.postMessage(data);
    } catch (error: unknown) {
      console.error("iOS Bridge Error:", (error as Error).message);
    }
  }

  public sendChannelId(channelId: string): void {
    this.initialize();
    if (!this.isIOSAvailable()) return;
    try {
      this.webkit.sendChannelId.postMessage(channelId);
    } catch (error: unknown) {
      console.error("iOS Bridge Error:", (error as Error).message);
    }
  }

  public unsetChannelId(): void {
    this.initialize();
    if (!this.isIOSAvailable()) return;
    try {
      this.webkit.unsetChannelId.postMessage("");
    } catch (error: unknown) {
      console.error("iOS Bridge Error:", (error as Error).message);
    }
  }

  public openBrowser(url: string): void {
    this.initialize();
    if (!this.isIOSAvailable()) {
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    try {
      if (this.webkit.openBrowser && typeof this.webkit.openBrowser.postMessage === "function") {
        this.webkit.openBrowser.postMessage(url);
      } else {
        // Native app hasn't registered an "openBrowser" message handler yet -
        // fall back to opening a new browser context instead of navigating
        // away inside the current WKWebView.
        window.open(url, "_blank", "noopener,noreferrer");
      }
    } catch (error: unknown) {
      console.error("iOS Bridge Error:", (error as Error).message);
    }
  }

  public isIOSAvailable(): boolean {
    this.initialize();
    return !!(window as any).webkit?.messageHandlers;
  }
}
